import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 12,
	height: 8,
	viewBox: "0 0 12 8",
	fill: "#003366",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M10.59 0.589966L6 5.16997L1.41 0.589966L0 1.99997L6 7.99997L12 1.99997L10.59 0.589966Z",
	fill: "current"
}));
export default SvgChevronDown;
